import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {SemanticSearchPropertyDto} from "../types/SemanticSearchPropertyDto";
import {getAmplitudeSemanticSearchPropertyListItem} from "./get_amplitude_semantic_search_property_list_item";
import {AmplitudeSemanticSearchModalSize} from "./get_semantic_search_modal_size";
import {SEMANTIC_SEARCH_AMPLITUDE_LOCATION} from "./semantic_search_amplitude_location";

type SemanticSearchSelectedItem =
    | {itemCategory: "property"; property: SemanticSearchPropertyDto; index: number}
    | {itemCategory: "see_all_offers"; itemName: string};

interface ITrackAmplitudeSemanticSearchSelectItemParams {
    modalSize: AmplitudeSemanticSearchModalSize | null;
    analyticSessionId: string | null | undefined;
    item: SemanticSearchSelectedItem;
}

export const trackAmplitudeSemanticSearchSelectItem = ({modalSize, analyticSessionId, item}: ITrackAmplitudeSemanticSearchSelectItemParams) => {
    const productFields =
        item.itemCategory === "property"
            ? getAmplitudeSemanticSearchPropertyListItem({property: item.property, index: item.index})
            : {
                  item_id: null,
                  property_id: null,
                  item_name: item.itemName,
                  item_category: "see_all_offers",
                  index: null
              };

    trackAmplitudeEvent("select_item", {
        item_list_id: null,
        item_list_name: "Asystent AI",
        location: SEMANTIC_SEARCH_AMPLITUDE_LOCATION,
        analytic_session_id: analyticSessionId ?? null,
        modal_size: modalSize,
        ...productFields
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {SemanticSearchPropertyDto} from "../types/SemanticSearchPropertyDto";
import {getAmplitudeSemanticSearchPropertyListItem} from "./get_amplitude_semantic_search_property_list_item";
import {AmplitudeSemanticSearchModalSize} from "./get_semantic_search_modal_size";
import {SEMANTIC_SEARCH_AMPLITUDE_LOCATION} from "./semantic_search_amplitude_location";

type SemanticSearchSelectedItem =
    | {itemCategory: "property"; property: SemanticSearchPropertyDto; index: number}
    | {itemCategory: "see_all_offers"; itemName: string};

interface ITrackAmplitudeSemanticSearchSelectItemParams {
    modalSize: AmplitudeSemanticSearchModalSize | null;
    analyticSessionId: string | null | undefined;
    item: SemanticSearchSelectedItem;
}

export const trackAmplitudeSemanticSearchSelectItem = ({modalSize, analyticSessionId, item}: ITrackAmplitudeSemanticSearchSelectItemParams) => {
    const productFields =
        item.itemCategory === "property"
            ? getAmplitudeSemanticSearchPropertyListItem({property: item.property, index: item.index})
            : {
                  item_id: null,
                  property_id: null,
                  item_name: item.itemName,
                  item_category: "see_all_offers",
                  index: null
              };

    trackAmplitudeEvent("select_item", {
        item_list_id: null,
        item_list_name: "Asystent AI",
        location: SEMANTIC_SEARCH_AMPLITUDE_LOCATION,
        analytic_session_id: analyticSessionId ?? null,
        modal_size: modalSize,
        ...productFields
    });
};
